import axios from "axios";
import React from "react";
import {useParams } from "react-router-dom";
import { baseURL } from "../Config/Config";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";
import TestButttons from "./TestButttons";
import Modal from "./test_result_modal";
import CountDownTimer from "./timer/CountDownTimer";

export default function TestUmumiy() {
  const initialState = {};

//   let { test_id } = useParams();
  let { subject_id } = useParams();
  const [test_id, setTestid] = React.useState()
  const [detailTest, setDetailTest] = React.useState();
  const [timeLimit, setTimeLimit] = React.useState(1);
  const [numAnswer, setNumAnswer] = React.useState(1);
  const [testResult, setTestResult] = React.useState(initialState);
  const [testAnswer, setTestAnswer] = React.useState(new Set());
  const [openModal, setOpenModal] = React.useState(false);
  const [testNatija, setTestNatija] = React.useState();
  const testOrder = []
  React.useEffect(() => {
    axios
      .get(`${baseURL}quiz_app/common-quizs/`)
      .then((response) => {
        setTestid(response.data[0].id)
        setDetailTest(response.data[0].questions);
        setNumAnswer(response.data[0].questions.length);
        setTimeLimit(response.data[0].time);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  if (!detailTest) return null;
  const THREE_DAYS_IN_MS = timeLimit * 60;
  const NOW_IN_MS = new Date().getTime();

  const dateTimeAfterThreeDays = NOW_IN_MS + THREE_DAYS_IN_MS;

  var size = Object.keys(testResult).length;


  const hadleClick = (testid, answerid, test_id, _) => {
    setTestResult((prev) => ({
      ...prev,
      [`question-${test_id}`]: answerid,
    }));
    setTestAnswer(new Set(testAnswer.add(testid)));
  };


  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  };
  const handleTestSubmit = (e) => {
    e.preventDefault();
    if (numAnswer == size) {
      axios
        .post(`${baseURL}quiz_app/test-check/${test_id}/`, testResult, { headers })
        .then((response) => {
          setTestNatija(response.data);
          setOpenModal(true);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      alert("Hammasini belgilang!")
    }

  };
  return (
    <div>
      <Navbar />
      <div className="container">
        <div className="text-box">
          <div className="text-left">
            <div className="test-questions">
              {detailTest.map((test, index_savol) => {
                initialState[`question-${test.id}`] = 0;
                testOrder.push(test.id)

                return (
                  <div key={test.id}>
                    <div className="savol-title" key={test.id}>
                      <span>{index_savol + 1}-Savol</span>
                    </div>
                    <div className="savol-name">
                      <p>{test.content}</p>
                    </div>
                    {test.answers.map((answer, index) => {
                      return (
                        <div className="options" key={index}>
                          <div className="option">
                            <label>
                              <span>{answer.content}</span>
                              <input
                                type="radio"
                                id={test.id}
                                onClick={(e) =>
                                  hadleClick(index_savol + 1, answer.content, test.id, e)
                                }
                                name={`test${test.id}`}
                              />
                            </label>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
            <div className="modalBtn">
              <button className="btn" onClick={handleTestSubmit}>
                Jo‘natish
              </button>
              <Modal
                test_id={test_id}
                subject_id={'umumiy'}
                open={openModal}
                testNatija={testNatija}
                size={size}
                testOrder={testOrder}
                onClose={() => setOpenModal(false)}
              />
            </div>
          </div>
          <div className="text-right timer">
            <div className="test-timer">
              <p>Test vaqti</p>
              <CountDownTimer targetDate={dateTimeAfterThreeDays} />
              <TestButttons numAnswer={numAnswer} testAnswer={testAnswer} />
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
